import {
  CustomRiskLevel,
  RISK_LEVEL_CLASSES,
  RISK_LEVEL_ICON_CLASSES,
} from "src/core/constants/risk";

type RiskClassType = "icon" | "dot";

const RISK_CLASS_MAP: Record<RiskClassType, Record<CustomRiskLevel, string>> = {
  icon: {
    ...RISK_LEVEL_ICON_CLASSES,
  },
  dot: {
    ...RISK_LEVEL_CLASSES,
  },
};

/**
 * @description Retourne la classe CSS associée à un type de risque et un niveau de risque.
 * @param type Type de risque (icon ou dot).
 * - icon: Classe CSS associée à l'icône (SVG) du risque.
 * - dot: Classe CSS associée à la pastille du risque.
 * @param level Niveau de risque.
 */
export const getRiskClass = (type: RiskClassType, level: CustomRiskLevel): string => {
  return RISK_CLASS_MAP[type][level] || "";
};
